import { Icon } from "@app/icons";
import type { ReactNode } from "react";

/** A chip with a ✕ that removes what it stands for (chosen trials, checks); put several in a ``.chips`` row. */
export function RemovableChip(props: {
  children: ReactNode;
  tone?: "g" | "y" | "b";
  title?: string;
  removeLabel: string;
  onRemove: () => void;
}) {
  return (
    <span className={`chip ${props.tone ?? ""}`.trim()} title={props.title}>
      {props.children}
      <button type="button" aria-label={props.removeLabel} onClick={props.onRemove}>
        <Icon name="close" size={10} />
      </button>
    </span>
  );
}
